import { render } from "./MyPublicationDigitalProducts.vue.js?vue&type=template&id=ca627a26!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationDigitalProducts.vue?vue&type=template&id=ca627a26"
import script from "./MyPublicationDigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationDigitalProducts.vue?vue&type=script&lang=js"
export * from "./MyPublicationDigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationDigitalProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/MyPublicationDigitalProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca627a26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca627a26', __exports__)) {
    api.reload('ca627a26', __exports__)
  }
  
  module.hot.accept("./MyPublicationDigitalProducts.vue.js?vue&type=template&id=ca627a26!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyPublicationDigitalProducts.vue?vue&type=template&id=ca627a26", () => {
    api.rerender('ca627a26', render)
  })

}


export default __exports__